<template>
		<div class="warp">
			<breadcrumb :back="true" :crubList="[{ name: '活动沙龙管理' }, { name: '活动列表', goback: true }, { name: '发布活动' }]" :title="'发布活动'" />
			<!-- 表单 -->
			<div class="box">
				<div class="forms">
					<div class="child">
						<div class="name">
							<span>*</span>
							活动标题：
						</div>
						<el-input v-model="sendInfo.activityTitle" type="textarea" autosize maxlength="80"></el-input>
					</div>
					<div class="error" v-if="errors['sendInfo.activityTitle']">错误提示：{{ errors['sendInfo.activityTitle'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							活动类型：
						</div>
						<el-select v-model="sendInfo.activityType" placeholder="请选择" >
							<el-option
							v-for="item in activeType"
							:key="item.id"
							:label="item.dictName"
							:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="error" v-if="errors['sendInfo.activityType']">错误提示：{{ errors['sendInfo.activityType'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							报名截止时间：
						</div>
						<el-date-picker
							size="small"
							v-model="sendInfo.registrationDeadline"
							format="yyyy-MM-dd HH:mm"
							value-format="yyyy-MM-dd HH:mm:ss"
							@change="changeDeadline"
							type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
					<div class="error" v-if="errors['sendInfo.registrationDeadline']">错误提示：{{ errors['sendInfo.registrationDeadline'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							活动开始时间：
						</div>
						<el-date-picker
							size="small"
							v-model="sendInfo.startDate"
							@change="changeStartDate"
							format="yyyy-MM-dd HH:mm"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
					<div class="error" v-if="errors['sendInfo.startDate']">错误提示：{{ errors['sendInfo.startDate'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							活动结束时间：
						</div>
						<el-date-picker
							size="small"
							v-model="sendInfo.endDate"
							@change="changeEndDate"
							format="yyyy-MM-dd HH:mm"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
					<div class="error" v-if="errors['sendInfo.endDate']">错误提示：{{ errors['sendInfo.endDate'] }}</div>

					<div class="childTextarea">
						<div class="name">
							<span>*</span>
							活动举办地址：
						</div>
						<div class="content"><el-input type="textarea" v-model="sendInfo.activityAddress" show-word-limit maxlength="100"></el-input></div>
					</div>
					<div class="error" v-if="errors['sendInfo.activityAddress']">错误提示：{{ errors['sendInfo.activityAddress'] }}</div>

					<div class="childTextarea">
						<div class="name">
							<span>*</span>
							活动主办单位：
						</div>
						<div class="content"><el-input type="textarea" v-model="sendInfo.activityOrganizer" show-word-limit maxlength="100"></el-input></div>
					</div>
					<div class="error" v-if="errors['sendInfo.activityOrganizer']">错误提示：{{ errors['sendInfo.activityOrganizer'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							适用人群：
						</div>
						<el-checkbox-group v-model="sendInfo.fitCrowd" style="padding-left: 25px;">
							<el-checkbox :label="i.value" v-for="(i,index) in status" :key="index">{{i.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div class="error" v-if="errors['sendInfo.fitCrowd']">错误提示：{{ errors['sendInfo.fitCrowd'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							来源：
						</div>
						<el-input v-model="sendInfo.source" maxlength="20"></el-input>
					</div>
					<div class="error" v-if="errors['sendInfo.source']">错误提示：{{ errors['sendInfo.source'] }}</div>

					<div class="child">
						<div class="name">
							<span>*</span>
							活动详情：
						</div>
						<div class="content super_prv">
							<!-- <div ref="wangEditor"></div> -->
							<!-- <wangEnduit
								style="width: 600px;min-height: 500px;"
								:EditorCont="sendInfo.activityDetails"
								@onEditorChange="onEditorChange"
							></wangEnduit> -->
              <wangEnduit v-model="sendInfo.activityDetails" :quill-index="0" my-editor="editor" :height="500" :upload="handleUploadEditor" />
              <el-button type="primary" class="ml10" @click="onPrivew" plain size="small">预览</el-button>
						</div>
					</div>
					<div class="error" v-show="errors['sendInfo.activityDetails']">错误提示：{{ errors['sendInfo.activityDetails'] }}</div>

					<div class="child">
					    <div class="name"><span>*</span>封面：</div>
					    <div class="content"><upLoad
						:action="'backstage/annex/file'"
						:accept="'image/png,image/jpg,image/jpeg,video/*'" 
						:size="20"
            is-need-limit
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="200"
            :autoCropHeight='200'
            :videoSize="100"
            :fixed="false"
						v-model="sendInfo.coverUrl"/>
						</div>
					</div>
					<div class="hint">图片仅支持png、jpg，建议高宽比为1:1，尺寸建议200*200px，大小不超过20M;视频大小不超过100M</div>
					<div class="error" v-if="errors['sendInfo.coverUrl']">错误提示：{{errors['sendInfo.coverUrl']}}</div>

					<div class="attachment child">
						<div class="name">
							附件：
						</div>
						<div class="content">
							<upLoadFiles
							v-model="sendInfo.fileList"
							:action="'/backstage/annex/files'"
							:size="20"
							:accept="'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword'"
							/>
						</div>
					</div>
          <div class="child">
						<div class="name"></div>
						<div class="content">
              <div class="singleBtn">
                <el-button type="primary" size="small" @click="submit">发布</el-button>
                <el-button size="small" @click="$router.back(-1)">取消</el-button>
              </div>
            </div>
					</div>
					
				</div>
			</div>
            <el-dialog title="预览" :visible.sync="dialogVisible" width="50%">
            <el-tabs type="border-card">
                    <el-tab-pane>
                        <span slot="label">pc</span>
                        <div v-html="sendInfo.activityDetails" class="prv_content isPc"></div>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label">移动端</span>
                        <div v-html="sendInfo.activityDetails" class="prv_content isApp"></div>
                    </el-tab-pane>
            </el-tabs>
                
            </el-dialog>
		</div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEditor from 'wangeditor';
import {getDict} from "@/axios";
import upLoad from '../../components/upLoads'
// import wangEnduit from '../../components/wangEnduit';
import wangEnduit from '../../components/Editor/index';
export default {
	components: {
		breadcrumb,
		upLoadFiles,
		upLoad,
		wangEnduit
	},
	data() {
		return {
      dialogVisible:false,
			sendInfo: {
				activityAddress: null,//活动举办地址
				activityDetails:null,//活动详情
				activityOrganizer: null,//活动主办单位
				activitySalonId: null,//活动沙龙ID，编辑时必传
				activityTitle: null,//活动标题
				activityType: null,//活动类型
				startDate: null,//活动开始时间
				endDate: null,//活动结束时间
				fileList: [],//附件
				coverUrl:'',//活动封面
				fitCrowd: [],//适用人群，ID集合，逗号分隔
				registrationDeadline: null,//报名截止时间
				source: null,//来源
			}, //提交
			editor: null ,//富文本编辑器容器
			activeType:[],
			status:[],//适用人群
		};
	},
	computed: {
		errors() {
			return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
		}
	},
	vuerify: {
		'sendInfo.coverUrl':{
		    test:function(){
		        if(this.sendInfo.coverUrl.length>0){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'上传活动封面'
		},
		'sendInfo.activityTitle': {
			test: function() {
				if (this.sendInfo.activityTitle) {
					return true;
				} else {
					return false;
				}
			},
			message: '填写活动标题'
		},
		'sendInfo.activityType': {
			test: function() {
				if (this.sendInfo.activityType) {
					return true;
				} else {
					return false;
				}
			},
			message: '选择活动类型'
		},
		'sendInfo.registrationDeadline': {
			test: function() {
				if (this.sendInfo.registrationDeadline) {
					return true;
				} else {
					return false;
				}
			},
			message: '选择报名截止时间'
		},
		'sendInfo.startDate': {
			test: function() {
				if (this.sendInfo.startDate) {
					return true;
				} else {
					return false;
				}
			},
			message: '选择活动开始时间'
		},
		'sendInfo.endDate': {
			test: function() {
				if (this.sendInfo.endDate) {
					return true;
				} else {
					return false;
				}
			},
			message: '选择活动结束时间'
		},
		'sendInfo.activityAddress': {
			test: function() {
				if (this.sendInfo.activityAddress) {
					return true;
				} else {
					return false;
				}
			},
			message: '填写活动举办地址'
		},
		'sendInfo.activityOrganizer': {
			test: function() {
				if (this.sendInfo.activityOrganizer) {
					return true;
				} else {
					return false;
				}
			},
			message: '填写活动主办单位'
		},
		'sendInfo.fitCrowd': {
			test: function() {
				if (this.sendInfo.fitCrowd.length > 0) {
					return true;
				} else {
					return false;
				}
			},
			message: '选择适用人群'
		},
		'sendInfo.source': {
			test: function() {
				if (this.sendInfo.source) {
					return true;
				} else {
					return false;
				}
			},
			message: '填写来源'
		},
		'sendInfo.activityDetails': {
			test: function() {
				if (this.sendInfo.activityDetails) {
					return true;
				} else {
					return false;
				}
			},
			message: '填写活动详情'
		}
	},
	created() {
		// 适用人群  客户类型
		getDict('CUSTOMER_TYPE').then(data=>{
		    this.status = data.CUSTOMER_TYPE;
		})
		// 活动类型
		this.$axiosz.get('/rpc/sysDict/parentId/1069409892302848').then(res=>{
		    if(res.code==200){
				this.activeType=res.data
		    }else{
		        this.$alert(res.msg)
		    }
		})

		if(this.$route.query.id){
			this.sendInfo.newId=this.$route.query.id;
			this.getDetail(this.$route.query.id);
		}
	},
	methods: {
    onPrivew(){
          if(!this.sendInfo.activityDetails || !this.sendInfo.activityDetails.trim()){
            this.$message.info('暂无内容不能预览')
            return 
          }
          this.dialogVisible = true
        },
     /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      console.time('start')
      // 上传 todu
      this.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {
        console.timeEnd('start')
        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        this.$alert('上传失败')
        console.log(e)
      })
    },
		changeDeadline(val){
			this.sendInfo.registrationDeadline = val
		},
		changeStartDate(val){
			this.sendInfo.startDate = val
		},
		changeEndDate(val){
			this.sendInfo.endDate = val
		},
		onEditorChange(val){
		  // let _html=val.container.innerHTML;
		  this.sendInfo.activityDetails=val;
		},
		getDetail(id){
			this.$axiosc.get('/backstage/activity/salon/details/'+id).then((r)=>{
			    if(r.code==200){
			        let dataInfo = r.data;
					let sendInfo={
					      activityAddress: dataInfo.activityAddress,//活动举办地址
					      activityDetails:dataInfo.activityDetails,//活动详情
					      activityOrganizer: dataInfo.activityOrganizer,//活动主办单位
					      activitySalonId: dataInfo.id,//活动沙龙ID，编辑时必传
					      activityTitle: dataInfo.activityTitle,//活动标题
					      activityType: dataInfo.activityType,//活动类型
					      startDate:dataInfo.startDate  ? dataInfo.startDate + ':00' : '',//活动开始时间
					      endDate:dataInfo.endDate ? dataInfo.endDate + ':00' : '',//活动结束时间
					      fileList: dataInfo.fileList,//附件
					      coverUrl:dataInfo.coverUrl,//活动封面
					      fitCrowd: dataInfo.fitCrowd,//适用人群，ID集合，逗号分隔
					      registrationDeadline:dataInfo.registrationDeadline ? dataInfo.registrationDeadline + ':00' : '',//报名截止时间
					      source: dataInfo.source,//来源
					}
					this.sendInfo=sendInfo;
					let fitCrowd=dataInfo.fitCrowd;
					let fitCrowdVal=[];
					for (let i in fitCrowd) {
						fitCrowdVal.push(fitCrowd[i].key)
					}
					this.sendInfo.fitCrowd=fitCrowdVal;
					// this.editor.txt.html(dataInfo.activityDetails)
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
		//提交
		submit: function() {
			this.$vuerify.clear();
			this.$vuerify.check();
			if(this.$vuerify.check()){
				let fitCrowd=this.sendInfo.fitCrowd;
				let fitCrowdDell='';
				if(fitCrowd.length>0){
					for (let i in fitCrowd) {
						if(fitCrowd.length>1){
							fitCrowdDell+=fitCrowd[i]+','
						}else{
							fitCrowdDell+=fitCrowd[i]
						}
					}
					// this.sendInfo.fitCrowd=fitCrowdDell
				}
				let sendInfo = JSON.parse(JSON.stringify(this.sendInfo));
				sendInfo.fitCrowd = fitCrowdDell
				// this.sendInfo.startDate = this.sendInfo.startDate + ':00';
				// this.sendInfo.endDate = this.sendInfo.endDate + ':00';
				// this.sendInfo.registrationDeadline = this.sendInfo.registrationDeadline + ':00';
				this.$axioscBody.post('/backstage/activity/salon/save',sendInfo).then((r)=>{
					if(r.code==200){
						this.$message({
							type: 'success',
							message: r.msg
						});
						this.$router.back();
					}else{
						this.$alert(r.msg);
					}
				})
			}else{

			}
		}
	},
	mounted() {
		// this.editor = new wangEditor(this.$refs.wangEditor);
		// this.editor.customConfig.onchange = html => {
		// 	//通过富文本变化赋值
		// 	// html 即变化之后的内容
		// 	this.sendInfo.activityDetails = html;
		// 	this.$vuerify.check(['sendInfo.activityDetails']);
		// };
		// this.editor.create();
	},
	watch:{
	}
};
</script>

<style lang="scss" scoped>
	/deep/ .el-message-box__wrapper{
		z-index: 10000;
	}
.warp {
  height:93%;
     overflow-x: hidden;
     overflow-y: auto;
	.box {
		padding-top: 20px;
		.forms {
			max-width: 650px;
			margin: auto;
			.child {
				.content {
					flex: 1;
					.el-textarea {
						width: 300px !important;
					}
					/deep/ .ql-container{
						min-height: 410px;
					}
				}
				/deep/ .el-select {
					width: 100%;
				}
			
				/deep/ .name {
					width: 100px !important;
					text-align: right;
				}
			}
			.hint {
				padding-left: 100px;
			}
			.error {
				padding-left: 100px;
			}
		}
	}
}
</style>
